/* eslint-disable import/prefer-default-export */

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function proccessError(errorData) {
  if (errorData.statusCode === 401) {
    return [errorData.message];
  }

  return errorData.message;
}
